import Image from "next/image";
import { getReadableImageUrl } from "@/lib/directus";
import { sanitizeHTML } from "@/lib/utils";

interface ArtistryBackedByScienceData {
  anchor_title?: string;
  heading: {
    title?: string;
  };
  text: {
    text?: string;
  };
  image: {
    alt?: string;
    image_file: {
      image: {
        id: string;
        filename_download: string;
      };
    };
  };
}

interface ArtistryBackedByScienceProps {
  data?: ArtistryBackedByScienceData;
}

export const fields = [
  "anchor_title",
  "heading.title",
  "text.text",
  "image.alt",
  "image.image_file.image.id",
  "image.image_file.image.filename_download",
] as const;

export default function ArtistryBackedByScience({ data }: ArtistryBackedByScienceProps) {
  const sectionId = (data?.anchor_title || 'ArtistryBackedByScience')
    .replace(/\s+/g, '-')
    .replace(/[^a-zA-Z0-9-_]/g, '')
    .replace(/-{2,}/g, '-');

  return (
    <section id={sectionId} className="bg-[#C4BAB2] py-[3.75rem]">
      <div className="container">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          <div className="relative min-h-[250px] md:min-h-0 order-1 md:order-2">
            <Image
              src={getReadableImageUrl(
                data?.image?.image_file?.image?.id || "",
                data?.image?.image_file?.image?.filename_download || ""
              )}
              alt={data?.image?.alt || ''}
              fill
              className="object-cover"
              quality={95}
              loading={"lazy"}
              sizes="(min-width: 768px) 50vw, 100vw"
            />
          </div>
          <div className="bg-[#635B56] p-8 md:p-12 lg:p-14 flex flex-col justify-center order-2 md:order-1">
            <h2 className="font-freightBig text-[2.25rem] font-normal leading-[3rem] text-white mb-6">
              {data?.heading?.title}
            </h2>
            <div
              className="text-white font-sans text-base font-normal leading-7 [&>p]:mb-4 [&>p:last-child]:mb-0"
              dangerouslySetInnerHTML={sanitizeHTML(data?.text?.text || '')}
            />
          </div>
        </div>
      </div>
    </section>
  );
}
